import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { breakpoints } from '@/styles'
import { ValueText } from '@/features/Application/elements'
import { InformationTable, TableTitle } from '@/features/Application/elements/tables'
import useMediaQuery from '@/hooks/use-media-query'
import StatusComponent from './status-component'
import MobileIdentityVerification from './mobile'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 18px;
`

const IdentityVerification = ({ data = {}, isLocked, isLoading, standalone = false }) => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const title = t('l.application.view.identity_verification.label', 'Identity Verification')
  const { rate, details = [] } = data
  const status = {
    poor: t('l.application.view.poor.label', 'Poor'),
    average: t('l.application.view.average.label', 'Average'),
    very_good: t('l.application.view.very_good.label', 'Very Good'),
    excellent: t('l.application.view.excellent.label', 'Excellent'),
    analyzing: t('l.application.view.analyzing.label', 'Analyzing')
  }

  const statusText = status[rate]
  const LABELS = {
    drivers_license: t('b.profile.edit.drivers_license.text', "Driver's Licence"),
    identification_document: t(
      'b.profile.edit.identification_document.text',
      'Identification Document'
    ),
    passport: t('b.profile.edit.passport.text', 'Passport'),
    health_insurance: t('b.profile.edit.health_insurance_card.text', 'Health Insurance Card'),
    permanent_resident: t('b.profile.edit.residence_card.text', 'Permanent Residence Card'),
    'Facial Verification': t('b.profile.edit.facial_verification.text', 'Facial Verification')
  }
  const columns = useMemo(
    () => [
      {
        Header: t('common.type', 'Type'),
        Cell: ({ row: { original } }) => {
          return (
            <ValueText type="small" isLocked={isLocked}>
              {LABELS[original?.type] ?? '-'}
            </ValueText>
          )
        }
      },
      {
        Header: t('common.status', 'Status'),
        Cell: ({ row: { original } }) => (
          <StatusComponent
            status={original?.status?.toLowerCase().replace(' ', '_')}
            isLocked={isLocked}
          />
        )
      },
      {
        id: 'empty',
        Header: ''
      }
    ],
    [isLocked, isLoading]
  )

  return (
    <Wrapper>
      <TableTitle
        title={title}
        showStatus={true}
        statusType={rate}
        statusText={statusText}
        isLocked={isLocked}
        isLoading={isLoading}
      />
      <InformationTable
        data={details}
        columns={columns}
        showBorder={standalone}
        hideHeader={isMobile}
        isLoading={isLoading}
      />
    </Wrapper>
  )
}

export { MobileIdentityVerification }
export default IdentityVerification
